import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import CompanyPage
  from '@fuww/library/src/Layouts/CompanyPage';
import { NextPageWithLayout } from 'next';
import TextWithImage from '../components/TextWithImage';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import Head from '../components/Head';
import Hero from '../components/Hero';
import { textWithImageConfigurations } from '../lib/imageConfigurations';
import getSourceSet from '../lib/getSourceSet';
import { useSiteContext } from '../components/SiteContext';
import articlesConnectionQuery
  from '../lib/queries/news/articlesConnectionQuery.graphql';
import withQuery from '../lib/withQuery';
import Articles from '../components/News/ArticleFeed';
import createCompanyBreadcrumbs from '../lib/createCompanyBreadcrumbs';
import { CompanyPageWithDataProperties } from './employer-branding';
import getPartnerVariables from '../lib/getPartnerVariables';
import {
  ArticlesConnectionQuery,
  ArticlesConnectionQueryVariables,
} from '../lib/graphql/api/graphql';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/oDXWBz9Sca_yMVrh6DPMM2HxoekhSjplz90GxelRvoE/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb250ZW50X21hcmtldGluZ19oZWFkZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/AHsoeZ9aB3iG6kGPeC469PMbQH4EQNeN2WbUxwYK4PM/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb250ZW50X21hcmtldGluZ19oZWFkZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/ckeTtHzDV_r1j51LGpTKTuBWoLrNyLiLBtW9pzdBWeQ/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb250ZW50X21hcmtldGluZ19oZWFkZXJfbW9iaWxlLmpwZw',
  ],
  desktop: [
    'https://r.fashionunited.com/-zOguRqXzjgJfgMMEtivOThkRnqre29_LPE_d8R3-q8/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb250ZW50X21hcmtldGluZ19oZWFkZXIuanBn',
    'https://r.fashionunited.com/j4aRL2fKLK2d_ALuMo32U80HTE8UIl4UHNWj5McJ6jg/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb250ZW50X21hcmtldGluZ19oZWFkZXIuanBn',
    'https://r.fashionunited.com/VKNzfeRf6urSjvB4lf70jpWcsOV7M2lnuAdCL3vjJvI/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb250ZW50X21hcmtldGluZ19oZWFkZXIuanBn',
    'https://r.fashionunited.com/GlmlVsy4n7_YnoI5Sc0pQN2mUHAuID-YhA_fPuy5Xv0/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb250ZW50X21hcmtldGluZ19oZWFkZXIuanBn',
  ],
};

const imageUrls = {
  advertorial: [
    'https://r.fashionunited.com/9zZ2tRmwRQzujwcwMFs3kjiKropy8_ICZz4ng3725tc/resize:fit:42:56:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9hZHZlcnRvcmlhbC5wbmc',
    'https://r.fashionunited.com/LuE-5A360F7sdlW5XhLXHJosv5WutpF09Dn188rvZF4/resize:fit:219:291:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9hZHZlcnRvcmlhbC5wbmc',
    'https://r.fashionunited.com/c0YsGeqJ0NuwCd-sJ7shHXyrxQAJjf70D8JZ9K9S1-U/resize:fit:460:612:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9hZHZlcnRvcmlhbC5wbmc',
    'https://r.fashionunited.com/0TVoQaz9jM-bYSNC5mJYzgm2Z5vySwSnGGkSxbprKeg/resize:fit:807:1074:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9hZHZlcnRvcmlhbC5wbmc',
  ],
  interview: [
    'https://r.fashionunited.com/NVSADgmLqszYWLQ6rqT15BeurLMUpxM2WCU__niiqBs/resize:fit:42:28:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJ2aWV3LnBuZw',
    'https://r.fashionunited.com/f1SpPZO-ecVS-9-TZvd4yy8h5ptm-XZlfPL6q3F4i1k/resize:fit:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJ2aWV3LnBuZw',
    'https://r.fashionunited.com/aq4kncA92dxsCivVKXkGHFqR3kSTIxbepXMKAIxSaYs/resize:fit:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJ2aWV3LnBuZw',
    'https://r.fashionunited.com/FApff9s0P52_f5anARJkjcy1MZAilAF2i3FXxYirdes/resize:fit:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvaW50ZXJ2aWV3LnBuZw',
  ],
  translation: [
    'https://r.fashionunited.com/No2c0ZD2Jnn-dH5pvSUT60NlQ9JrGepQ2qTmd4OogPA/resize:fit:42:28:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHJhbnNsYXRpb24ucG5n',
    'https://r.fashionunited.com/tBsv8I8y2QqdEAnIlpuM5hNd5Vasg4FF1lhwuUvz_jg/resize:fit:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHJhbnNsYXRpb24ucG5n',
    'https://r.fashionunited.com/dX4YyyMEdokaN8mRh0TZU3aQ8z0OumsP7jbpUJe693k/resize:fit:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHJhbnNsYXRpb24ucG5n',
    'https://r.fashionunited.com/6OHX4kbN6iaxv7X43p2ROBi9f-LgJ7M38mwcFw8tONo/resize:fit:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdHJhbnNsYXRpb24ucG5n',
  ],
  socialMediaCampaign: [
    'https://r.fashionunited.com/UaAanGxGjlA1oGtFCU_KtdQoBMbXLcLnWct2QyjYTwY/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9zb2NpYWxfbWVkaWFfY2FtcGFpZ24uanBn',
    'https://r.fashionunited.com/x0ngy_F9F0vnJKYk_-SdN372xAOGnTfW_hSZcGGOsUE/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9zb2NpYWxfbWVkaWFfY2FtcGFpZ24uanBn',
    'https://r.fashionunited.com/xCsMQli-riLuG_iNdfrpig1gzRH4U5igFc5WGUU077s/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9zb2NpYWxfbWVkaWFfY2FtcGFpZ24uanBn',
    'https://r.fashionunited.com/kgNAFxvPqdnNXlPCaTe_iyj4_e9c-bYfG8oSLGDIpNw/resize:fill:920:613:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9zb2NpYWxfbWVkaWFfY2FtcGFpZ24uanBn',
  ],
  companyPage: [
    'https://r.fashionunited.com/o5GcY1aWx0TI364C0AMWr4ywFodnGpxhRaELJHik6BE/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb21wYW55X3BhZ2UuanBn',
    'https://r.fashionunited.com/tlJoZq16MNLmUAMyTqKEd0TeetP2q04Ouf3nMDulIcc/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb21wYW55X3BhZ2UuanBn',
    'https://r.fashionunited.com/jWtMaGCKkt8URcP6ge4oo_VTBj8MNX9ohmKpJ3SdExs/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb21wYW55X3BhZ2UuanBn',
    'https://r.fashionunited.com/WjmllClo7u-I2vIk785m2EQWJoUjGmz4C95PNkZWPD0/resize:fill:920:613:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9jb21wYW55X3BhZ2UuanBn',
  ],
  newsletter: [
    'https://r.fashionunited.com/RnFTSh_mkyIBHJxJ6Ao_ikzupnonb00UUF6GjDOT9lc/resize:fit:42:56:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9uZXdzbGV0dGVyLnBuZw',
    'https://r.fashionunited.com/0xgu9jvjWixQbP8mT1NAbGneofRcqsuDYRSsz8uJMlA/resize:fit:219:291:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9uZXdzbGV0dGVyLnBuZw',
    'https://r.fashionunited.com/vVtQFmtftDBf-KDONoYd3YSTZFANETUwHbDBkQrHyiY/resize:fit:460:612:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9uZXdzbGV0dGVyLnBuZw',
    'https://r.fashionunited.com/ATlPNQfmjDHiMhM-5g5Kb_bzITfQy5dH6fo6Sl4-qWM/resize:fit:807:1074:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9uZXdzbGV0dGVyLnBuZw',
  ],
};

const ContentMarketing = ({
  data,
  fetchMore,
  loading,
  variables,
}: CompanyPageWithDataProperties) => {
  const intl = useIntl();

  const breadcrumbs = createCompanyBreadcrumbs({
    intl,
    crumbRoute: 'content-marketing',
    crumbLabel: intl.formatMessage(messages['contentMarketing.header']),
  });

  return (
    <>
      <Head
        title={intl.formatMessage(messages['contentMarketing.header'])}
        description={intl.formatMessage(
          messages['contentMarketing.description'],
        )}
      />
      <CompanyPage
        advertorials={(
          <Articles
            data={data}
            fetchMore={fetchMore}
            loading={loading}
            preloadFirst
            variables={variables}
          />
        )}
        partnerContentTitle={intl.formatMessage(
          messages['contentMarketing.partnerContentTitle'],
        )}
        breadcrumbs={breadcrumbs}
        description={intl.formatMessage(
          messages['contentMarketing.description'],
        )}
        title={intl.formatMessage(messages['contentMarketing.header'])}
        textWithImageComponents={(
          <>
            <TextWithImage
              title={intl.formatMessage(
                messages['contentMarketing.advertorialTitle'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              imagePosition="left"
              description={(
                <div
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: intl.formatMessage(
                      messages['contentMarketing.advertorialBody'],
                    ),
                  }}
                />
              )}
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              imageUrls={imageUrls.advertorial}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.advertorial,
              )}
            />
            <TextWithImage
              title={intl.formatMessage(
                messages['contentMarketing.newsletterTitle'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              imagePosition="right"
              description={(
                <div
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: intl.formatMessage(
                      messages['contentMarketing.newsletterBody'],
                    ),
                  }}
                />
              )}
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              imageUrls={imageUrls.newsletter}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.newsletter,
              )}
            />
            <TextWithImage
              description={intl.formatMessage(
                messages['contentMarketing.interviewBody'],
              )}
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              imagePosition="left"
              imageUrls={imageUrls.interview}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.interview,
              )}
              title={intl.formatMessage(
                messages['contentMarketing.interviewTitle'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['contentMarketing.translationBody'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.translation}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.translation,
              )}
              title={intl.formatMessage(
                messages['contentMarketing.translationTitle'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['contentMarketing.socialMediaCampaignBody'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.socialMediaCampaign}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.socialMediaCampaign,
              )}
              title={intl.formatMessage(
                messages['contentMarketing.socialMediaCampaignTitle'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['contentMarketing.buttonLabel'],
              )}
              buttonHref="mailto:media@fashionunited.com"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['contentMarketing.companyPageBody'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.companyPage}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.companyPage,
              )}
              title={intl.formatMessage(
                messages['contentMarketing.companyPageTitle'],
              )}
            />
          </>
        )}
      />
    </>
  );
};

const ContentMarketingWithQuery = withQuery<
  ArticlesConnectionQuery,
  ArticlesConnectionQueryVariables
>(ContentMarketing);

const ContentMarketingPage: NextPageWithLayout = () => {
  const { newsboard } = useSiteContext();

  return (
    <ContentMarketingWithQuery
      errorMessage="Error while loading news articles"
      query={articlesConnectionQuery}
      variables={getPartnerVariables(newsboard)}
    />
  );
};

ContentMarketingPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Content marketing banner image"
        imageUrls={headerImageUrls}
      />
  )}
  >
    {page}
  </Layout>
);

export default ContentMarketingPage;
